import React from "react";
import { Empty } from "antd";

const ListIsEmpty: React.FC = () => {
  return <Empty description="Список пуст" />;
};

export default ListIsEmpty;